import { useFlag } from '@unleash/proxy-client-vue';

import { captureException } from '@/wabunka-src/common/utils/sentry';

// フラグ名を Union 型で定義
// フラグ名が増えたらここに追加する
export type FeatureFlagName = 'wabunkaSwitchToMultiPricing' | 'wabunkaAiChat' | 'wabunkaWaitlist';

const useIsMounted = () => {
  const isMounted = ref(false);
  if (getCurrentInstance()) {
    onMounted(() => {
      isMounted.value = true;
    });
  } else {
    isMounted.value = typeof window !== 'undefined';
  }
  return isMounted;
};

// サーバーとハイドレーションでは常に false にして、HTML をフラグの値によらず 1 通りにする（D-026）
export const useFeatureFlag = (flagName: FeatureFlagName) => {
  let flag: Ref<boolean> = ref(false);

  try {
    flag = useFlag(flagName);
  } catch (error) {
    // フィーチャーフラグの取得に失敗した場合、エラーをSentryに送信する
    const newError = new Error('Failed to get feature flag: ' + (error as Error).message);
    captureException(newError, 'wabunka');
  }

  const isMounted = useIsMounted();
  const featureFlag = computed(() => isMounted.value && flag.value);

  return {
    featureFlag,
  };
};
